// Authored guide bodies, bundled as raw markdown via Vite's `?raw` import.
// Add a new entry here whenever a guide gets a real write-up — the slug
// must match the `GuideEntry.slug` in `../guides.ts`.
import firstQuery from "./first-query.md?raw"
import noCode from "./no-code.md?raw"
import buildWithAi from "./build-with-ai.md?raw"
import bulkExport from "./bulk-export.md?raw"
import brandComparison from "./brand-comparison.md?raw"
import storeProfiling from "./store-profiling.md?raw"
import areaIdentification from "./area-identification.md?raw"
import voidAnalysis from "./void-analysis.md?raw"
import analogModeling from "./analog-modeling.md?raw"
import areaDevelopmentReporting from "./area-development-reporting.md?raw"
import matchLocations from "./match-locations.md?raw"

// INVARIANT: only add bodies for guides that are neither `locked` nor
// case studies. Bodies are bundled client-side and the gate is CSS-only,
// so a gated guide's body would ship to every anonymous visitor. Server-
// side body gating has to land before gated guides get real content.
export const guideBodies: Record<string, string> = {
  "first-query": firstQuery,
  "no-code": noCode,
  "build-with-ai": buildWithAi,
  "bulk-export": bulkExport,
  "brand-comparison": brandComparison,
  "store-profiling": storeProfiling,
  "area-identification": areaIdentification,
  "void-analysis": voidAnalysis,
  "analog-modeling": analogModeling,
  "area-development-reporting": areaDevelopmentReporting,
  "match-locations": matchLocations,
}

export function getGuideBody(slug: string): string | undefined {
  return guideBodies[slug]
}
